export default {
  suffix(h, conf, key) {
    return <template slot="extra">{conf.__slot__[key]}</template>;
  },
};
